<HomeNavBar/>
<section>
  <div class="container-fluid">
    <div class="row content-section">
      <div class="col-lg-3 d-none d-lg-flex bg-white shadow px-2">
        <AllPortals @portal_profile="portalProfile" @portal_selected="fetchPostsByPortal" @portalAccepted="handlePortalAccepted" ref="portals" :portal_admin="portal_admin" @sub_portals="handle_sub_portals" @clear_reports="clear_reports_filter"/>
      </div>
       <div class="col-xl-9 col-lg-12 col-md-12 col-12 p-0 padpro-screen scroll-container">
        <div class="card bg-white border-0">
          <div class="mx-3 mt-2 border-bottom margin-0">
            <h5 class="fw-500">{{$route.params.board_name}}</h5>
          </div>
        </div>
  <div class="p-2 h-100">
    <div class="d-flex gap-3 overflow-auto h-100 w-100">

      <!-- Existing Buckets -->
      <Column
        v-for="(bucket, index) in buckets"
        :key="bucket.id"
        :bucket="bucket"
        @add-task="addTask(index,bucket.id)"
        @delete-bucket="deleteBucket(index)"
      />

      <div class="" v-if="isAddingBucket" style="min-width: 260px;">
          <input
            v-model="newBucketTitle"
            class="form-control form-control-sm border-bottom text-xxs"
            ref="newBucketInput"
            @keydown.enter="add_new_column"
            @blur="add_new_column"
            placeholder="Enter column name"
          />
      </div>

      <!-- Add Button -->
      <div class="d-flex align-items-start"  style="min-width: 260px;" v-else>
        <label class="fs-xsm fw-500" @click="startAddingBucket"> Add a new column</label>
      </div>

    </div>
  </div>

    </div>
    </div>
</div>
</section>